const BASE_BANK_ACCOUNTS = "/bank_accounts";
const BASE_BANK_MOVEMENTS = "/bank_movements";
const BASE_LEDGER_ALLOCATIONS = "/ledger_allocations";
const BASE_LEDGER_ALLOCATION_CATEGORIZATION_RULES = "/ledger_allocation_categorization_rules";
const BASE_ACCOUNTING_BUDGETS = "/accounting_budgets";

export const ACCOUNTING_ENDPOINTS = {
  // Tags comptables : le catalogue (Paramètres) et leur pose sur les deux écrans.
  ACCOUNTING_TAGS: "/accounting_tags",
  ACCOUNTING_TAG: (id: number) => `/accounting_tags/${id}`,
  BANK_MOVEMENT_TAGS: (bankMovementId: string) => `${BASE_BANK_MOVEMENTS}/${bankMovementId}/tags`,
  BULK_BANK_MOVEMENT_TAGS: `${BASE_BANK_MOVEMENTS}/bulk_tags`,
  LEDGER_ALLOCATION_TAGS: (ledgerAllocationId: string) => `${BASE_LEDGER_ALLOCATIONS}/${ledgerAllocationId}/tags`,
  BULK_LEDGER_ALLOCATION_TAGS: `${BASE_LEDGER_ALLOCATIONS}/bulk_tags`,
  // Bank Accounts
  LIST_BANK_ACCOUNTS: BASE_BANK_ACCOUNTS,
  SHOW_BANK_ACCOUNT: (id: number) => `${BASE_BANK_ACCOUNTS}/${id}`,
  CREATE_BANK_ACCOUNT: BASE_BANK_ACCOUNTS,
  UPDATE_BANK_ACCOUNT: (id: number) => `${BASE_BANK_ACCOUNTS}/${id}`,
  DELETE_BANK_ACCOUNT: (id: number) => `${BASE_BANK_ACCOUNTS}/${id}`,
  PAYBOX_COLLECTION: (id: number) => `${BASE_BANK_ACCOUNTS}/${id}/paybox_collection`,
  // Bridge
  BRIDGE_CONNECT: `${BASE_BANK_ACCOUNTS}/bridge_connect`,
  BRIDGE_ACCOUNTS: `${BASE_BANK_ACCOUNTS}/bridge_accounts`,
  BRIDGE_PROVIDERS: `${BASE_BANK_ACCOUNTS}/bridge_providers`,
  BRIDGE_MATCH: `${BASE_BANK_ACCOUNTS}/bridge_match`,
  BRIDGE_REFRESH: `${BASE_BANK_ACCOUNTS}/bridge_refresh`,
  BRIDGE_RECONNECT: `${BASE_BANK_ACCOUNTS}/bridge_reconnect`,
  BRIDGE_DESYNC: `${BASE_BANK_ACCOUNTS}/bridge_desync`,
  BRIDGE_DELETE: `${BASE_BANK_ACCOUNTS}/bridge_delete`,
  // Bank Movements
  LIST_BANK_MOVEMENTS: BASE_BANK_MOVEMENTS,
  MERGE_BANK_MOVEMENTS: `${BASE_BANK_MOVEMENTS}/merge`,
  SHOW_BANK_MOVEMENT: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}`,
  CREATE_BANK_MOVEMENT: BASE_BANK_MOVEMENTS,
  LIST_BANK_MOVEMENT_ACCOUNTS: `${BASE_BANK_MOVEMENTS}/accounts`,
  LIST_BANK_MOVEMENT_PAYMENT_MODES: `${BASE_BANK_MOVEMENTS}/payment_modes`,
  LIST_BANK_MOVEMENT_FUSION_CANDIDATES: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/fusion_candidates`,
  FUSE_BANK_MOVEMENT: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/fuse`,
  SPLIT_BANK_MOVEMENT: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/split`,
  UPDATE_BANK_MOVEMENT: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}`,
  DELETE_BANK_MOVEMENT: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}`,
  RUN_BANK_MOVEMENTS_PROBABLE_MATCHING: `${BASE_BANK_MOVEMENTS}/run_probable_matching`,
  PROBABLE_MATCHING_STATUS: (runId: string) =>
    `${BASE_BANK_MOVEMENTS}/probable_matching_status?run_id=${encodeURIComponent(runId)}`,
  VALIDATE_BANK_MOVEMENT_PROBABLE_FUSION: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/validate_probable_fusion`,
  DECLINE_BANK_MOVEMENT_PROBABLE_FUSION: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/decline_probable_fusion`,
  // DEC-15 : l'arbitrage d'un écart entre le montant saisi et le relevé.
  ACCEPT_BANK_MOVEMENT_BANK_AMOUNT: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/accept_bank_amount`,
  KEEP_BANK_MOVEMENT_OWN_AMOUNT: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/keep_own_amount`,
  BANK_MOVEMENTS_DISCREPANCY_SUMMARY: `${BASE_BANK_MOVEMENTS}/bank_discrepancy_summary`,
  // DEC-15, second volet : les doublons que la tâche de nettoyage écarte.
  BANK_MOVEMENT_DUPLICATE_CANDIDATES: `${BASE_BANK_MOVEMENTS}/duplicate_candidates`,
  REATTACH_BANK_MOVEMENT_DUPLICATE: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/reattach_duplicate_to_original`,
  DELETE_BANK_MOVEMENT_DUPLICATE: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/delete_duplicate`,
  DISMISS_BANK_MOVEMENT_DUPLICATE: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/dismiss_duplicate`,
  // ADM-681: recalcule à la demande le solde d'affectation d'un mouvement.
  RECALCULATE_BANK_MOVEMENT_BALANCE: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/recalculate_balance`,
  LIST_LEDGER_ALLOCATIONS: (bankMovementId?: string) =>
    bankMovementId
      ? `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations`
      : BASE_LEDGER_ALLOCATIONS,
  CREATE_LEDGER_ALLOCATION: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations`,
  LIST_LEDGER_ALLOCATION_OPERATION_TYPES: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/operation_types`,
  CREATE_LEDGER_ALLOCATION_OPERATION_TYPE: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/operation_types`,
  UPDATE_LEDGER_ALLOCATION_OPERATION_TYPE: (bankMovementId: string, operationTypeId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/operation_types/${operationTypeId}`,
  DELETE_LEDGER_ALLOCATION_OPERATION_TYPE: (bankMovementId: string, operationTypeId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/operation_types/${operationTypeId}`,
  MERGE_LEDGER_ALLOCATION_OPERATION_TYPE: (bankMovementId: string, operationTypeId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/operation_types/${operationTypeId}/merge`,
  LEDGER_ALLOCATION_OPERATION_TYPES_IMPORT_TEMPLATE: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/operation_types/import_template`,
  LIST_LEDGER_ALLOCATION_CATEGORIZATION_RULES: BASE_LEDGER_ALLOCATION_CATEGORIZATION_RULES,
  CREATE_LEDGER_ALLOCATION_CATEGORIZATION_RULE: BASE_LEDGER_ALLOCATION_CATEGORIZATION_RULES,
  SHOW_LEDGER_ALLOCATION_CATEGORIZATION_RULE: (id: string) =>
    `${BASE_LEDGER_ALLOCATION_CATEGORIZATION_RULES}/${id}`,
  UPDATE_LEDGER_ALLOCATION_CATEGORIZATION_RULE: (id: string) =>
    `${BASE_LEDGER_ALLOCATION_CATEGORIZATION_RULES}/${id}`,
  DELETE_LEDGER_ALLOCATION_CATEGORIZATION_RULE: (id: string) =>
    `${BASE_LEDGER_ALLOCATION_CATEGORIZATION_RULES}/${id}`,
  UPDATE_LEDGER_ALLOCATION: (id: string) => `${BASE_LEDGER_ALLOCATIONS}/${id}`,
  DELETE_LEDGER_ALLOCATION: (id: string) => `${BASE_LEDGER_ALLOCATIONS}/${id}`,
  LIST_STOCK_CATEGORIES: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/stock_categories`,
  LIST_STOCK_FAMILIES: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/stock_families`,
  LIST_STOCK_REFERENCES: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/ledger_allocations/stock_references`,
  // ADM-736 : export XLSX asynchrone du grand livre des stocks (filtré comme la vue).
  EXPORT_LEDGER_ALLOCATIONS_XLSX: `${BASE_LEDGER_ALLOCATIONS}/export_xlsx`,
  LEDGER_OPERATION_TYPE_FACETS: `${BASE_LEDGER_ALLOCATIONS}/operation_type_facets`,
  // ADM-609: organization-scoped variants used by the Grand Livre filters
  // (not bound to a specific bank movement).
  LIST_LEDGER_STOCK_FAMILIES: `${BASE_LEDGER_ALLOCATIONS}/stock_families`,
  LIST_LEDGER_STOCK_REFERENCES: `${BASE_LEDGER_ALLOCATIONS}/stock_references`,
  REFUND_EMPLOYEES_SEARCH: `${BASE_LEDGER_ALLOCATIONS}/refund_employees_search`,
  REFUND_OPERATIONS: `${BASE_LEDGER_ALLOCATIONS}/refund_operations`,
  ECOMMERCE_ORDERS_SEARCH: `${BASE_LEDGER_ALLOCATIONS}/ecommerce_orders_search`,
  // Settlements
  LIST_SETTLEMENTS: "/settlements",
  SHOW_SETTLEMENT: (id: string) => `/settlements/${id}`,
  CREATE_SETTLEMENT: "/settlements",
  UPDATE_SETTLEMENT: (id: string) => `/settlements/${id}`,
  DELETE_SETTLEMENT: (id: string) => `/settlements/${id}`,
  LIST_SETTLEMENT_ACCOUNTS: "/settlements/accounts",
  LIST_SETTLEMENT_PAYMENT_METHODS: "/settlements/payment_methods",
  LIST_SETTLEMENT_ALLOCATIONS: (settlementId: string) =>
    `/settlements/${settlementId}/allocations`,
  CREATE_SETTLEMENT_WITH_MOVEMENT: "/settlements/create_with_movement",
  CREATE_SETTLEMENT_MOVEMENT: (settlementId: string) =>
    `/settlements/${settlementId}/create_movement`,
  CREATE_REMISE: "/settlements/create_remise",
  REMISE_PDF: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/remise_pdf`,
  // SEPA
  SEPA_EXPORT: `${BASE_BANK_MOVEMENTS}/sepa_export`,
  SEPA_VALIDATE: `${BASE_BANK_MOVEMENTS}/sepa_validate`,
  SEPA_ELIGIBILITY: `${BASE_BANK_MOVEMENTS}/sepa_eligibility`,
  // YTI-1732 : les fiches de remise SEPA, créées par sepa_export.
  LIST_SEPA_REMITTANCES: "/sepa_remittances",
  SHOW_SEPA_REMITTANCE: (id: string) => `/sepa_remittances/${id}`,
  DOWNLOAD_SEPA_REMITTANCE: (id: string) => `/sepa_remittances/${id}/download`,
  REGENERATE_SEPA_REMITTANCE: (id: string) => `/sepa_remittances/${id}/regenerate`,
  ROLLBACK_SEPA_REMITTANCE: (id: string) => `/sepa_remittances/${id}/rollback`,
  // Synthesis
  SYNTHESIS: `${BASE_LEDGER_ALLOCATIONS}/synthesis`,
  SYNTHESIS_EXPORT: `${BASE_LEDGER_ALLOCATIONS}/synthesis_export`,
  SYNTHESIS_DETAIL: `${BASE_LEDGER_ALLOCATIONS}/synthesis_detail`,
  // ADM-621 : variantes org-scoped des catégories, pour la page Budget qui les
  // gère hors du drawer d'un mouvement bancaire.
  LIST_ORG_OPERATION_TYPES: `${BASE_LEDGER_ALLOCATIONS}/operation_types`,
  CREATE_ORG_OPERATION_TYPE: `${BASE_LEDGER_ALLOCATIONS}/operation_types`,
  PCG_IMPORT_OPERATION_TYPES: `${BASE_LEDGER_ALLOCATIONS}/operation_types/pcg_import`,
  PCG_REVERT_OPERATION_TYPES: `${BASE_LEDGER_ALLOCATIONS}/operation_types/pcg_revert`,
  UPDATE_ORG_OPERATION_TYPE: (operationTypeId: string) =>
    `${BASE_LEDGER_ALLOCATIONS}/operation_types/${operationTypeId}`,
  DELETE_ORG_OPERATION_TYPE: (operationTypeId: string) =>
    `${BASE_LEDGER_ALLOCATIONS}/operation_types/${operationTypeId}`,
  MERGE_ORG_OPERATION_TYPE: (operationTypeId: string) =>
    `${BASE_LEDGER_ALLOCATIONS}/operation_types/${operationTypeId}/merge`,
  ORG_OPERATION_TYPES_IMPORT_TEMPLATE: `${BASE_LEDGER_ALLOCATIONS}/operation_types/import_template`,
  // ADM-621 : budgets prévisionnels + date de clôture comptable.
  LIST_ACCOUNTING_BUDGETS: BASE_ACCOUNTING_BUDGETS,
  UPSERT_ACCOUNTING_BUDGET: BASE_ACCOUNTING_BUDGETS,
  UPDATE_ACCOUNTING_BUDGET: (id: number) => `${BASE_ACCOUNTING_BUDGETS}/${id}`,
  DELETE_ACCOUNTING_BUDGET: (id: number) => `${BASE_ACCOUNTING_BUDGETS}/${id}`,
  ACCOUNTING_SETTINGS: "/accounting_settings",
  // Bridge Transfer
  BRIDGE_TRANSFER: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/bridge_transfer`,
  BRIDGE_CONFIRM: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/bridge_confirm`,
  BRIDGE_PAYMENT_STATUS: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/bridge_payment_status`,
  BRIDGE_RELEASE: (bankMovementId: string) =>
    `${BASE_BANK_MOVEMENTS}/${bankMovementId}/bridge_release`,
  // Entry Templates
  LIST_ENTRY_TEMPLATES: "/accounting_entry_templates",
  CREATE_ENTRY_TEMPLATE: "/accounting_entry_templates",
  DELETE_ENTRY_TEMPLATE: (id: string) => `/accounting_entry_templates/${id}`,
} as const;
